<div class="my-ticket-wrap" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
    <ng-container *ngIf="isUsserLogged; else notLogged">
        <div class="filter-ticket" [class.reduced]="viewConfigurations.reduceMyTicketsFilter">
            <ng-container *ngIf="!viewConfigurations.reduceMyTicketsFilter; else reducedFilters">
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Active" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Active)">A</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Win" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Win)">D</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Cashout" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Cashout)">CO</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Lost" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Lost)">G</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Storno" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Storno)">S</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Cashback" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Cashback)">CB</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.All" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.All)" i18n="My Tickets tab all tickets Radio text@@myTicketsTabAll">SVI</span>

            </ng-container>

            <ng-template #reducedFilters>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.All" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.All)" i18n="My Tickets filter@@myTicketsTabFilterAll">SVI</span>

                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Active" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Active)" i18n="My Tickets filter@@myTicketsTabFilterActive">Aktivni</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Win" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Win)" i18n="My Tickets filter@@myTicketsTabFilterWon">Dobitni</span>
                <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Lost" (click)="ticketsFilterStatusChange(ticketFilterStatusEnum.Lost)" i18n="My Tickets filter@@myTicketsTabFilterLost">Gubitni</span>
            </ng-template>
            
            


        </div>
        <div class="ticket-item {{ticketStatusEnum[ticket.status.code] | lowercase}}" *ngFor="let ticket of tickets" (click)="openTicketDetails(ticket)">
            <div class="flex">
                <div class="flex-column">
                    <span class="highlight">{{ticket.ticketNumber}}</span>
                    <span><ng-container i18n="Ticket Pay in text@@TicketPayIn">Uplata</ng-container>: <br>{{ticket.payin | number:'1.2-2'}} {{currency}}</span>
                </div>
                <div class="flex-column">
                    <span class="highlight">
                        <ng-container i18n="My Tickets played ticket number of events@@myTicketsTabEvents">Parovi</ng-container>: {{ticket.numberOfMatches}}</span>
                    <span>
                        <ng-container i18n="Ticket Pay out text@@TicketPayOut">Isplata</ng-container>: <br>{{ticket.possiblePayout | number:'1.2-2'}} {{currency}}
                    </span>
                </div>
                <span class="title" *ngIf="ticket.isFreeBet; else notFreebet">FREE BET</span>
                <ng-template #notFreebet>
                    <span class="title" *ngIf="ticket.numberOfCombinations > 1" i18n="ticket System tab title@@ticketTabSystem">Sistem</span>
                    <span class="title" *ngIf="ticket.numberOfCombinations == 1" i18n="normal ticket@@normalTicket">Običan</span>
                </ng-template>
                
            </div>
            <div class="flex ticket-status-wrap">
                <!-- <div class="flex ticket-status {{ticketStatusEnum[ticket.status.code] | lowercase}}" >
                    <span>{{ticket.status.name}}</span>
                </div> -->
                <span class="flex ticket-cashout" *ngIf="ticket.cashoutValue != null && ticket.cashoutValue != ''" (click)="sellBet(ticket); $event.stopPropagation();">
                    <span i18n="Casheback text@@Casheback">CashOut</span>: {{ticket.cashoutValue | number:'1.2-2'}} {{currency}}
                </span>
            </div>
        </div>

        <div class="no-result" *ngIf="tickets && tickets.length === 0">
            <span i18n="there are no tickets for the selected filter@@TicketDoesNotExist">Nema tiketa za odabrani filter</span>
        </div>
    </ng-container>

    <ng-template #notLogged>
        <div class="no-result">
          <span i18n="My Tickets not logged in@@MyTicketsPlsLogin">Molimo vas da se ulogujete <br />kako biste imali pristup listi odigranih tiketa.</span>
        </div>
    </ng-template>
</div>
